import React from "react"
import styled from "styled-components"
import Link from "../../component/link"
import OptimizedImage from "../../component/OptimizedImage"

const DivProducts = styled.div`
  li:hover > a {
    color: #1465ff;
  }
  .br-top {
    border-top: 1px solid lightgrey;
  }
`

const MenuProducts = currentLocation => {
  const PRODUCTOS_SOFTWARE = [
    {
      action: "nomina",
      name: "Nómina Electrónica",
    },
    {
      action: "pos",
      name: "POS (Punto de venta)",
    },
    {
      action: "automatico",
      name: "Inventarios",
    },
    {
      action: "produccion",
      name: "Producción",
    },
    {
      action: "ventas",
      name: "Fuerza de ventas",
    },
    {
      action: "electronica",
      name: "Facturación en bloque",
    },
    {
      action: "financiero",
      name: "Indicadores financieros",
    },
    {
      action: "inventarios",
      name: "Bodegas (control de inventarios)",
    },
    {
      action: "adicional",
      name: "Usuarios",
    },
    {
      action: "documento",
      name: "Documento soporte",
    },
    {
      action: "facturacionelectronica",
      name: "Facturación electrónica",
    },
    {
      action: "titulovalor",
      name: "Título valor",
    },
  ]

  return (
    <DivProducts className="border-top-menu absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-2xl sm:px-0 lg:ml-0 ">
      <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
        <div className="px-5 pt-0 py-5 bg-white space-y-6 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8">
          <div className="grid">
            <div className="ml-4 text-left">
              <p className="pt-6 pb-2 text-base font-medium text-gray-900">
                Tipos de Software
              </p>
              <ul className="grid grid-cols-1 2xl:grid-cols-3 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3">
                <li>
                  <Link to="/producto?contador">
                    <OptimizedImage
                      imagePath="icon4.webp"
                      alt="Software para contadores profesionales - Claus"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="/producto?empresa">
                    <OptimizedImage
                      imagePath="icon1.webp"
                      alt="Software para gestión empresarial y fiscal - Claus"
                    />
                  </Link>
                </li>
                <li>
                  <Link to="/producto?electronica">
                    <OptimizedImage
                      imagePath="icon5.webp"
                      alt="Facturación electrónica certificada por la DIAN - Claus"
                    />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="ml-4 text-left br-top mt-2 pt-2">
              <p className="pt-6 pb-2 text-base font-medium text-gray-900">
                Aplicaciones
              </p>
              <ul className="grid grid-cols-1 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 gap-1 gap-x-4">
                {PRODUCTOS_SOFTWARE &&
                  PRODUCTOS_SOFTWARE.map(({ action, name }, i) => {
                    return (
                      <li key={i}>
                        <Link
                          to={`/aplicaciones#${action}`}
                          className="inline-block pl-0 p-2 text-sm text-gray-500 rounded-lg"
                        >
                          {name}
                        </Link>
                      </li>
                    )
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </DivProducts>
  )
}

export default MenuProducts
